import React from 'react'

import AnalyticsSectionContent, { IAnalyticsSectionContentProps } from './AnalyticsSectionContent'

const TopQueriesNoClicks: React.SFC<IAnalyticsSectionContentProps> = (props) => (
  <AnalyticsSectionContent title="Top Queries with No Clicks" {...props} />
)

export default TopQueriesNoClicks
